import { useEffect, useState } from "react";

// HOOKS
import { usePayment } from "src/hooks/context";
import { useGetAgreementFromForeignId } from "../../hooks/useGetAgreementFromForeignId";
import { useTriloCallback } from "../../hooks/useTriloCallback";

// COMPONENTS
import CamelBottom from "src/components/Layout/CamelBottom/CamelBottom";
import CamelTop from "src/components/Layout/CamelTop/CamelTop";

// ASSETS
import { PaymentSummary } from "src/components/Callback/PaymentSummary";
import { Receipt } from "src/components/Callback/Receipt";

type SummaryProps = {
    foreignId: string;
}

export const Summary = ({ foreignId }: SummaryProps) => {
    const { paymentState, updatePaymentState } = usePayment();
    const [agreementId, setAgreementId] = useState<string | null>(null);
    const { triloCallback } = useTriloCallback();
    const { agreementFromForeignId } = useGetAgreementFromForeignId();
    const [transferId, setTransferId] = useState<string | null>(null);

    useEffect(() => {
        if (foreignId === null || foreignId === undefined) {
            console.error("foreign id is null or undefined");
            return
        }
        if (paymentState.amount !== null && paymentState.amount !== undefined) {
            return
        }
        async function getTransferFn() {
            if (foreignId === null || foreignId === undefined) {
                console.error("foreign id is null or undefined");
                return
            }

            const { id: agreementId, transfer } = await agreementFromForeignId({ foreignId });

            if (transfer === null || transfer === undefined) {
                console.error("transfer is null or undefined");
                return
            }
            console.log("[Summary]", { transfer });
            let status = "PENDING";
            if (transfer.status === "SETTLED" || transfer.status === "ACCEPTED") {
                status = "PAID";
            } else if (transfer.isError) {
                status = "ERROR";
            }
            updatePaymentState({
                transferId: transfer.id,
                amount: transfer.amount,
                note: transfer.note,
                status,
                recipient: {
                    id: "",
                    name: transfer.details?.name !== null ? transfer.details?.name : undefined,
                    logo: transfer.details?.avatar !== null ? transfer.details?.avatar : undefined,
                }
            });

            if (agreementId === null || agreementId === undefined) {
                console.error("agreementId is null or undefined");
                return
            }
            setAgreementId(agreementId);
        }

        getTransferFn();
    }, [foreignId, triloCallback, setTransferId, transferId, agreementFromForeignId, updatePaymentState, paymentState.amount]);

    return <>
        <CamelTop>
            <PaymentSummary />
        </CamelTop>
        <CamelBottom>
            {agreementId !== null && <Receipt agreementId={agreementId} />}
        </CamelBottom>
    </>;
};
